import React from "react";
// components
import PageHeader from "../../../PageHeader/PageHeader";
import PageInfo from "../../components/PageInfo"
import PageState from "../../components/PageState";
//styles
import styles from "./Index.module.css"
import stylesList from "../DetTrorViPaa/Index.module.css"

export default function HvemErVi() {

    return(
        <PageState
            pageName="HvemViEr"
            render={({ data, sections, sectionNames }) => {

                const { Sec1, Sec2, Sec3, Sec4} = data

                return (
                    <div>
                        <PageHeader
                            title={data.PageHeader.title}
                            sections={sections}
                            sectionNames={sectionNames}
                            description={data.PageHeader.text}
                            image={data.PageHeader.imageUrl}/>
                        {/* Kristus i centrum */}
                        <section id={Sec1.secId} className={styles.sec1}>
                            <PageInfo
                                title={Sec1.header}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }}/>}
                                version={"v4"}
                                image={Sec1.imageUrl}/>
                        </section>
                        {/* En kirke er mennesker */}
                        <section id={Sec2.secId} className={styles.sec2}>
                            <PageInfo
                                title={Sec2.header}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec2.text }}/>}
                                version={"v5"}/>
                        </section>
                        {/* Vigtig viden og praktiske detaljer */}
                        <section id={Sec3.secId} className={styles.sec3}>
                            <div className={stylesList.fundamentet}>
                                <div className={stylesList.backgroundImage} style={{ backgroundImage: `url(${Sec3.imageUrl})`, backgroundPosition: "center"}}></div>
                                <div className={stylesList.fundamentetInfo}>
                                    <h1>{Sec3.header}</h1>
                                    <p>{Sec3.text}</p>
                                </div>
                            </div>
                            <div>
                                {/* En selvstændig frimenighed */}
                                <section id={Sec3.item1.id}>
                                    <div className={stylesList.listItem1}>
                                    <div>
                                        <h2 className={stylesList.listItemTitle}>{Sec3.item1.title}</h2>
                                        <div className={stylesList.listItemText1} dangerouslySetInnerHTML={{ __html: Sec3.item1.text }}/>
                                    </div>
                                </div>
                                </section>

                                {/* En del af luthersk Mission */}
                                <section id={Sec3.item2.id}>
                                    <div className={stylesList.listItem2}>
                                        <div>
                                            <h2 className={stylesList.listItemTitle}>{Sec3.item2.title}</h2>
                                            <div className={stylesList.listItemText2} dangerouslySetInnerHTML={{ __html: Sec3.item2.text }}/>
                                        </div>
                                    </div>
                                </section>
                                
                                {/* Bliv medlem af Hillerød Frimenighed */}
                                <section id={Sec3.item3.id}>
                                    <div className={stylesList.listItem1}>
                                        <div>
                                            <h2 className={stylesList.listItemTitle}>{Sec3.item3.title}</h2>
                                            <div className={stylesList.listItemText1} dangerouslySetInnerHTML={{ __html: Sec3.item3.text }}/>
                                            <h3 className={stylesList.listItemSubTitle}>{Sec3.item3.subTitle}</h3>
                                            <div className={stylesList.listItemText1} dangerouslySetInnerHTML={{ __html: Sec3.item3.subText }}/>
                                        </div>
                                    </div>
                                </section>

                                {/* Bliv medlem af LMBU */}
                                <section id={Sec3.item4.id}>
                                    <div className={stylesList.listItem2}>
                                        <div>
                                            <h2 className={stylesList.listItemTitle}>{Sec3.item4.title}</h2>
                                            <div className={stylesList.listItemText2} dangerouslySetInnerHTML={{ __html: Sec3.item4.text }}/>
                                        </div>
                                    </div>
                                </section>

                                {/* Bliv frivillig */}
                                <section id={Sec3.item5.id}>
                                    <div className={stylesList.listItem1}>
                                        <div>
                                            <h2 className={stylesList.listItemTitle}>{Sec3.item5.title}</h2>
                                            <div className={stylesList.listItemText1} dangerouslySetInnerHTML={{ __html: Sec3.item5.text }}/>
                                        </div>
                                    </div>
                                </section>

                                {/* Giv en gave */}
                                <section id={Sec3.item6.id}>
                                    <div className={stylesList.listItem2}>
                                        <div>
                                            <h2 className={stylesList.listItemTitle}>{Sec3.item6.title}</h2>
                                            <div className={stylesList.listItemText2} dangerouslySetInnerHTML={{ __html: Sec3.item6.text }}/>
                                            <h3 className={stylesList.listItemSubTitle}>{Sec3.item6.subTitle}</h3>
                                            <div className={stylesList.listItemText2} dangerouslySetInnerHTML={{ __html: Sec3.item6.subText }}/>
                                        </div>
                                    </div>
                                </section>

                                {/* Åndelig omsorg */}
                                {Sec3?.item7 && (
                                    <section id={Sec3.item7.id}>
                                        <div className={stylesList.listItem1}>
                                        <div>
                                            <h2 className={stylesList.listItemTitle}>{Sec3.item7.title}</h2>
                                            <div
                                            className={stylesList.listItemText2}
                                            dangerouslySetInnerHTML={{ __html: Sec3.item7.text }}
                                            />
                                            <h3 className={stylesList.listItemSubTitle}>{Sec3.item7.subTitle}</h3>
                                            <div
                                            className={stylesList.listItemText2}
                                            dangerouslySetInnerHTML={{ __html: Sec3.item7.subText }}
                                            />
                                        </div>
                                        </div>
                                    </section>
                                )}
                            </div>
                        </section>
                        
                        {/* privatlivspolitik */}
                        <section id={Sec4.secId} className={styles.sec4}>
                            <div className={styles.sec4Content}>
                                <h2>{Sec4.header}</h2>
                                <div dangerouslySetInnerHTML={{ __html: Sec4.text }}/>
                            </div>
                        </section>
                    </div>
                );
            }
        }/>
    );
}